<template>
  <div id="app">
    <nav-bar></nav-bar>
    <router-view></router-view>
  </div>
</template>

<style>
@import "./assets/css/starter.css";
@import "./assets/css/font-awesome.min.css";
@import "./assets/css/login-form.css";
@import url("https://fonts.googleapis.com/css?family=Montserrat");
@import url("https://fonts.googleapis.com/css?family=Lato");
</style>

<script>
import NavBar from "./components/NavBar.vue";

export default {
  name: "Home",
  components: { NavBar }
};
</script>